import { useState } from 'react'
import Grid from "@mui/material/Grid2";
import { Button, TextareaAutosize, Typography, Card, CardContent, Chip, Divider } from '@mui/material';
import Image from '../../Utils/getImage';
import GetLink from '../../Utils/GetLink';
import instance from '../../Utils/api';
import { toast } from 'react-toastify';
import ShoppingBagIcon from '@mui/icons-material/ShoppingBag';
import AssignmentIcon from '@mui/icons-material/Assignment';
import PersonIcon from '@mui/icons-material/Person';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import CommentIcon from '@mui/icons-material/Comment';
import '../styles/components/Order_Items.scss';
import DesignServicesIcon from "@mui/icons-material/DesignServices";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";


const OrderItems = ({ suborder, fetchOrderById, paymentsData }) => {
    const [reason, setReason] = useState('');

    const fetchOrderAlteration = async (id, reason) => {
        if (!reason) {
            return toast.error('Please enter a reason for alteration');
        }
        try {
            const response = await instance.patch("/Order/RaiseOrderAlteration", {
                Suborder_id: id,
                reason: reason
            });

            if (response.status === 200) {
                toast.success(response.data.message);
                fetchOrderById();
            }
        } catch (err) {
            console.log(err);
        }
    };


    const labelText =
        suborder?.Tailor || suborder?.Master || suborder?.MaggamWorker ? "Order In Progress" :
            suborder?.status === "Alteration"
                ? "Alteration request raised"
                : suborder?.final_image
                    ? "Order Ready"
                    : paymentsData?.[0]?.status === "Done"
                        ? "Order In Progress"
                        : suborder?.assigned_to
                            ? "Order under Review"
                            : "Order Placed";

    const getStatusColor = (status) => {
        const statusColors = {
            "Alteration request raised": { bg: "#FFF4E5", color: "#E67E22" },
            "Order Ready": { bg: "#E1FCEF", color: "#14804A" },
            "Order In Progress": { bg: "#EBF0FA", color: "#2264E5" },
            "Order under Review": { bg: "#EDEDFC", color: "#5E5ADB" },
            "Order Placed": { bg: "#FCEBEA", color: "#FF928A" },
            "Unassigned": { bg: "#FCEBEA", color: "#FF928A" },
            "Assigned": { bg: "#F1FDFF", color: "#3CC3DF" },
            "Delivered": { bg: "#007C40", color: "#006400" },
            "In Payment": { bg: "#EBF0FA", color: "#2264E5" },
            "In Progress": { bg: "#FCF2E6", color: "#AA5B00" },
            "Pending": { bg: "#FCF2E6", color: "#AA5B00" },
            "In Transit": { bg: "#EDEDFC", color: "#5E5ADB" },
            "Completed": { bg: "#E1FCEF", color: "#14804A" },
            "Canceled": { bg: "#FFEDEF", color: "#D1293D" },
            default: { bg: "#E9EDF5", color: "#333" },
        };
        return statusColors[status] || statusColors.default;
    };

    console.log(suborder)
    return (
        <Card>
            <CardContent >
                <Grid container spacing={3}>
                    {/* Product Image and Name */}
                    <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 3 }}>
                        <div className="order_product_details">

                            {/* {suborder?.design_id?.picture?.map((img, index) => (
                                <div key={index} className="order_product_image">
                                    <Image
                                        src={img}
                                        alt={`design-${index}`}
                                        width={200}
                                        height={200}
                                    />
                                </div>
                            ))} */}
                            <div className="product-image-wrapper">
                                <Swiper
                                    spaceBetween={20}
                                    autoplay={{
                                        delay: 3000,
                                        disableOnInteraction: false,
                                    }}
                                    modules={[Autoplay, Pagination]}
                                    pagination={{ clickable: true }}
                                    loop={true}
                                    className="product-swiper"
                                >
                                    {suborder?.design_id?.picture?.map((img, index) => (
                                        <SwiperSlide key={index}>
                                            <div className="swiper-image-container">
                                                <Image
                                                    src={img}
                                                    alt={`design-${index}`}
                                                    width={200}
                                                    height={200}
                                                    className="swiper-image"
                                                />
                                            </div>
                                        </SwiperSlide>
                                    ))}
                                </Swiper>
                            </div>
                            <div className='order_product_content'>
                                <Typography variant='h5'>{suborder?.design_id?.name || "---"}</Typography>
                                {suborder?.amount && (
                                    <Typography>₹{suborder?.amount}/-</Typography>
                                )}
                            </div>
                        </div>
                    </Grid>

                    {/* Order Details */}
                    <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 9 }}>
                        <div className="order_information">
                            <div className='order_product_content'>
                                <ShoppingBagIcon />
                                <Typography >Order Information</Typography>
                            </div>

                            <div className='order_product_items'>
                                <Typography variant='h5'>Order ID</Typography>
                                <Typography>{suborder?.sub_order_id || "---"}</Typography>
                            </div>

                            <div className='order_product_items'>
                                <Typography variant='h5'>Design Name</Typography>
                                <Typography>{suborder?.design_id?.name || "---"}</Typography>
                            </div>

                            <div className='order_product_items'>
                                <Typography variant='h5'>Size</Typography>
                                <Typography>{suborder?.size || "---"}</Typography>
                            </div>

                            <div className='order_product_items'>
                                <Typography variant='h5'>Quantity</Typography>
                                <Typography>{suborder?.quantity || "---"}</Typography>
                            </div>

                            <div className='order_product_items'>
                                <Typography variant='h5'>Status</Typography>
                                <Typography >
                                    <span style={{
                                        padding: "4px",
                                        backgroundColor: getStatusColor(suborder.status).bg,
                                        color: getStatusColor(suborder.status).color,
                                    }}>
                                        {suborder.status === "New Order received" ? "Order Placed" : suborder?.status}
                                    </span>
                                </Typography>
                            </div>

                            <div className='order_product_items'>
                                <Typography variant='h5'>Ordered For</Typography>
                                <Typography>{suborder?.ordered_for || "---"}</Typography>
                            </div>

                            {(
                                suborder?.documents?.length > 0 ||
                                suborder?.sheet ||
                                suborder?.final_image ||
                                (suborder?.design_id?.fabric_img?.length ?? 0) > 0 ||
                                (suborder?.fabric_img?.length ?? 0) > 0
                            ) && (
                                    <>
                                        <div className='order_product_content'>
                                            <AttachFileIcon />
                                            <Typography >Documents</Typography>
                                        </div>

                                        {suborder?.documents?.[0] && (
                                            <div className='order_product_items'>
                                                <Typography variant='h5'>Documents</Typography>
                                                <Typography>
                                                    <GetLink href={suborder.documents[0]} target="_blank" className="document-link">
                                                        View Document                                                    </GetLink>
                                                </Typography>
                                            </div>
                                        )}

                                        {suborder?.sheet && (
                                            <div className='order_product_items'>
                                                <Typography variant='h5'>Measurement Sheet</Typography>
                                                <Typography>
                                                    <GetLink href={suborder?.sheet}
                                                        target="_blank"
                                                        rel="noopener noreferrer">
                                                        View Measurement Sheet
                                                    </GetLink>
                                                </Typography>
                                            </div>
                                        )}

                                        {suborder?.final_image && suborder?.final_image_approval === true && (
                                            <div className='order_product_items'>
                                                <Typography variant='h5'>Final Pic</Typography>
                                                <Typography>
                                                    <GetLink href={suborder.final_image}
                                                        target="_blank"
                                                        rel="noopener noreferrer">
                                                        View Final Image
                                                    </GetLink>
                                                </Typography>
                                            </div>
                                        )}

                                        {/* {suborder?.fabric_img?.length > 0 && (
                                            <div className='order_product_items'>
                                                <Typography variant='h5'>Fabric Pic</Typography>
                                                <Typography>
                                                    <GetLink
                                                        href={suborder?.fabric_img}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                    >
                                                        View Fabric Image
                                                    </GetLink>
                                                </Typography>
                                            </div>
                                        )} */}
                                        {(suborder?.design_id?.fabric_img?.length > 0 || suborder?.fabric_img?.length > 0) && (
                                            <div className='order_product_items'>
                                                <Typography variant='h5'>Fabric Images</Typography>
                                                <div style={{ display: "flex", width: "70%", flexWrap: "wrap", }}>
                                                    {(suborder.design_id?.fabric_img || suborder?.fabric_img)?.map((img, index) => (
                                                        <Typography key={index} style={{ width: "30%", marginBottom: "10px" }}>
                                                            <GetLink
                                                                href={img}
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                View Fabric Image {index + 1}
                                                            </GetLink>
                                                        </Typography>
                                                    ))}
                                                </div>
                                            </div>
                                        )}





                                    </>
                                )}

                            {suborder?.AlterationReason && (
                                <div className='order_product_items'>
                                    <Typography variant='h5'>Alteration Reason</Typography>
                                    <Typography>{suborder?.AlterationReason || "---"}</Typography>
                                </div>
                            )}

                            <div className='order_product_content'>
                                <AssignmentIcon />
                                <Typography >Assign Details</Typography>
                            </div>

                            {suborder?.assigned_to?.name && (
                                <div className='order_product_items'>
                                    <Typography variant='h5'>Assigned to</Typography>
                                    <Typography>{suborder?.assigned_to?.name || "---"}</Typography>
                                </div>
                            )}

                            {/* <div className='order_product_items'>
                                <Typography variant='h5'>Fabric Status</Typography>
                                <Typography>
                                    <span style={{
                                        padding: "4px",
                                        backgroundColor: getStatusColor(suborder?.fabric_status).bg,
                                        color: getStatusColor(suborder?.fabric_status).color,
                                    }}>
                                        {suborder?.fabric_status || "---"}
                                    </span>
                                </Typography>
                            </div> */}

                            {/* {suborder?.deadline && (
                                <div className='order_product_items'>
                                    <Typography variant='h5'>Deadline</Typography>
                                    <Typography>
                                        {new Date(suborder.deadline).toLocaleDateString("en-IN", {
                                            timeZone: "Asia/Kolkata",
                                            day: "2-digit",
                                            month: "2-digit",
                                            year: "numeric"
                                        })}
                                    </Typography>
                                </div>
                            )} */}

                            {/* {suborder?.comment && (
                                <div className='order_product_items'>
                                    <Typography variant='h5'>Comments</Typography>
                                    <Typography>{suborder.comment}</Typography>
                                </div>
                            )} */}
                        </div>
                    </Grid>

                    <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 12 }}>
                        <div className="order_information">
                            {suborder?.status === "Order Delivered" &&
                                new Date() - new Date(suborder.updatedAt) <= 3 * 24 * 60 * 60 * 1000 && (
                                    <>
                                        <div className='order_product_content' >
                                            <DesignServicesIcon />
                                            <Typography >Request Alteration</Typography>
                                        </div>

                                        <div className='order_product_alteration'>
                                            <TextareaAutosize
                                                minRows={3}
                                                placeholder="Please describe the alteration needed..."
                                                value={reason}
                                                onChange={(e) => setReason(e.target.value)}
                                                className="alteration-textarea"
                                            />

                                            <Button
                                                variant="contained"
                                                className="alteration-button"
                                                onClick={() => fetchOrderAlteration(suborder._id, reason)}
                                                disabled={!reason.trim()}
                                            >
                                                Raise Alteration
                                            </Button>

                                            <Typography>
                                                *Valid for 3 days from delivery
                                            </Typography>
                                        </div>
                                    </>
                                )}
                        </div>
                    </Grid>

                </Grid>
            </CardContent>
        </Card>
    );
};

export default OrderItems;
